import { Box, Typography } from '@mui/material'
import { type ApprovalComment } from '../../../Pages/IncomeApproval/IncomeApprovalDetail'
import { FormatDateValue } from '../../../core/Utilities'
import ChatBubbleIcon from '@mui/icons-material/ChatBubble'

interface IncomeApprovalCommentsCardProps {
  comments: ApprovalComment[]
}

export function IncomeApprovalCommentsCard (props: IncomeApprovalCommentsCardProps): JSX.Element {
  return (
    <Box className='CardDisplay'>
      <Typography variant='h6' fontWeight={'bold'}>Comments</Typography>
      {props.comments.length === 0
        ? <>
          <ChatBubbleIcon fontSize='large' sx={{ color: '#4DA4A4', pl: '60px' }} />
          <Typography variant='body1' sx={{ color: 'text.secondary' }}>No Comments Added</Typography>
        </>
        : <>
          {props.comments.map((comment, index) => (
            <Box key={index} sx={{ mb: 2, p: 1, border: '1px solid #ccc', borderRadius: '4px' }}>
              <Typography variant="body1" fontWeight={'bold'}>{comment.type}</Typography>
              <Typography variant="body1">{comment.comment}</Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>{comment.userName}</Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>{FormatDateValue(comment.dateOf)}</Typography>
            </Box>
          ))}
        </>}
    </Box>
  )
}
